import { defineAsyncComponent } from 'vue'
import { tabOutlineLayoutDashboard } from 'quasar-extras-svg-icons/tabler-icons-v3'

import type { FeatureConfig, MainFeatureTwin, FeatureParameterConfigs } from 'src/models'
import type { DashboardTileAction } from 'src/components/features/DashboardFeature'

/** One tab of a FeatureTabsFeature. Expression semantics mirror FeatureTabTile. */
export interface FeatureTabsTabConfig {
  /** Tab name. A JEXL expression resolving to an array expands into one tab per value. */
  tabName: string
  tabLabel?: string
  /** $dtId of the child feature to render (JEXL-evaluated). */
  tabFeature: string
  hideTab?: string
  tabCssStyle?: string
  tabCssClass?: string
  /** Stable key derived from the evaluated index (see FeatureTabTile). */
  tabKey?: string
}

/** One weighted run of the header title. `text` may be a JEXL expression. */
export interface FeatureTabsTitleRun {
  text?: string
  bold?: boolean
}

/** dtmi:com:arcadis:app:FeatureTabsFeature;1 */
export interface FeatureTabsFeatureTwin extends MainFeatureTwin {
  /** Feature parameters, as on a dashboard. Used in tab/header expressions. */
  parameters?: FeatureParameterConfigs
  /** Explicit tab configurations. When empty/undefined, tabs derive from child features. */
  tabs?: Record<string, FeatureTabsTabConfig>
  /** `setParameter` actions executed on tab select with `{tab, params}` in context. */
  actions?: { [key: string]: DashboardTileAction }
  /** Parameter holding the selected tab (two-way synced). */
  tabVariableName?: string
  tabAlign?: 'left' | 'center' | 'right'
  tabsCssStyle?: string
  contentCssStyle?: string
  /** Styled header title runs. Falls back to the feature title/label. */
  headerTitleRuns?: Record<string, FeatureTabsTitleRun>
  headerSubtitle?: string
  stickyMode?: 'none' | 'toolbar' | 'full'
  hideToolbar?: boolean
  /** Automatically sync selected twins to the store when selection changes */
  syncSelection?: boolean
}

const featureConfig: FeatureConfig = {
  main: {
    mainComponent: defineAsyncComponent(() => import('./FeatureTabsFeatureMain.vue')),
    fullWidth: true,
    icon: tabOutlineLayoutDashboard,
    label: 'Feature tabs'
  }
}

export default featureConfig
